(function () {
  function setupEditorialPages() {
    var path = window.location.pathname.replace(/\/+$/, '');
    var pageNames = {
      '/pages/about-us': 'about',
      '/pages/mission': 'mission',
      '/pages/design': 'design'
    };
    var pageName = pageNames[path];
    if (!pageName) return;

    document.documentElement.classList.add('jjt-editorial-page', 'jjt-editorial-' + pageName);

    var labels = {
      about: 'About us',
      mission: 'Our mission',
      design: 'Design'
    };

    document.querySelectorAll('#MainContent .hero__title, #MainContent > .shopify-section.index-section h2').forEach(function (heading) {
      heading.textContent = labels[pageName];
    });
  }

  function sentenceCaseEditorialHeadings() {
    var path = window.location.pathname.replace(/\/+$/, '');
    if (path !== '/pages/mission' && path !== '/pages/practitioner-program') return;

    document.querySelectorAll('#MainContent h1, #MainContent h2, #MainContent h3').forEach(function (heading) {
      var text = (heading.textContent || '').trim();
      if (text.replace(/\s+/g, '').toLowerCase() === 'practitionerprogram') {
        heading.textContent = 'Practitioner program';
        return;
      }
      if (!text || text !== text.toUpperCase() || !/[A-Z]/.test(text)) return;

      var normalized = text.toLowerCase().replace(/(^|[.!?]\s+)([a-z])/g, function (_, lead, letter) {
        return lead + letter.toUpperCase();
      });
      normalized = normalized
        .replace(/jiu-jitsu/gi, 'Jiu-Jitsu')
        .replace(/\bprssr\b/gi, 'PRSSR');
      heading.textContent = normalized;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupEditorialPages);
    document.addEventListener('DOMContentLoaded', sentenceCaseEditorialHeadings);
  } else {
    setupEditorialPages();
    sentenceCaseEditorialHeadings();
  }
}());
